import { Modal } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { formatDate } from "../../Date";
import { BASE_URL, IMAGE_URL } from "../../../config/axios";
// import { formatDate } from "../Date";
import U1 from './ProfileOptions/1.png'
import U2 from './ProfileOptions/2.png'
import U3 from './ProfileOptions/3.png'
import U4 from './ProfileOptions/4.png'
import U5 from './ProfileOptions/5.png'
import U6 from './ProfileOptions/6.png'
import U7 from './ProfileOptions/7.png'
import U8 from './ProfileOptions/8.png'
import U9 from './ProfileOptions/9.png'
import { generateCustomFileForUpload, handleErrorToast } from "../../CustomFunctions";
import { toast } from "react-toastify";
import { AddwithBlueCircle, UpdatePencil } from "../../AllSvg";


const ProfileUploadModal = ({ pic, getUSerDetails, extra_close, pre_options = false, addUi = false }) => {

    const [show, setShow] = useState(false);
    const handleClose = () => {
        extra_close(false)
        setShow(false)
    };
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);


    const [selectedProfile, setSelectedProfile] = useState(pic?.profilepic || null)
    const [selectedProfilePic, setSelectedProfilePic] = useState("${IMAGE_URL}user_profilepics/1.png");
    const [formDataa, setFormDataa] = useState({
        profilepic: null,
    });

    const [imagePreview, setImagePreview] = useState(null);
    const handleSelection = (pic) => {
        setSelectedProfile(pic);
        setImagePreview(null);
        setFormDataa({
            ...formDataa,
            profilepic: null,
        });
    }

    const userEmail = pic?.email || sessionStorage.getItem('email');

    const uploadFile = async (fileOrAvatar) => {
        const formDataa = new FormData();
        const symbols = '!@#$%^&*()_-+=';
        const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
        const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numbers = '0123456789';
        const now = new Date();
        const date = now.toLocaleDateString('en-GB').split('/').reverse().join('-');
        const time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-');
        const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
        let randomCode = '';
        for (let i = 0; i < 8; i++) {
            const randomIndex = Math.floor(Math.random() * allChars.length);
            randomCode += allChars[randomIndex];
        }

        if (fileOrAvatar instanceof File) {
            const customFile = generateCustomFileForUpload(fileOrAvatar, 'Aimantra');
            formDataa.append('profilepic', customFile);
        } else if (typeof fileOrAvatar === 'string') {
            const avatarUrl = `https://cipl-aimantra.s3.ap-south-1.amazonaws.com/${fileOrAvatar}?${new Date().getTime()}`;
            try {
                const response = await fetch(avatarUrl);
                const blob = await response.blob();
                const avatarFile = new File([blob], `avatar_${fileOrAvatar}`, { type: blob.type });
                formDataa.append('profilepic', avatarFile);
            } catch (error) {
                console.error('Error fetching avatar:', error);
            }
        }
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            let res = await axios.put(`${BASE_URL}/userdata/userdata/${userEmail}/`, formDataa, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (res.status === 200) {
                await getUSerDetails();
                toast.success("Profile updated successfully!");
                handleClose();
                extra_close(false);

            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);

        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
                setSelectedProfile(null);
                setFormDataa({
                    ...formDataa,
                    profilepic: file,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const triggerFileInput = () => {
        document.getElementById('fileInput').click();
    };


    const resetFileInput = () => {
        const fileInput = document.getElementById("fileInput");
        fileInput.value = null;
    };

    const handleSubmit = () => {

        const fileOrAvatar = formDataa.profilepic || selectedProfile || pic?.profilepic;
        uploadFile(fileOrAvatar);
    };

    console.log(selectedProfile, "profile");


    return (
        <>
            <button
                className="flex items-center gap-1 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition"
                onClick={handleShow}
                type="button"
            >
                {addUi ?
                    <div
                        style={{
                            width: '90px',
                            height: '90px',
                            borderRadius: '50%',
                            backgroundColor: 'rgb(200 223 243)',
                            position: 'relative',
                            margin: 'auto',
                        }}
                    >
                        <span
                            style={{
                                fontWeight: '400',
                                position: 'absolute',
                                top: '-4px',
                                fontSize: '68px',
                                right: '21px',
                                color: '#2576bc',
                            }}
                        >
                            +
                        </span>
                    </div>
                    :
                    <>
                        <UpdatePencil /><span>Edit</span>
                    </>
                }
            </button >
            <Modal show={show} dialogClassName="request-leave width-40vw">

                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div "
                            style={{ backgroundColor: '', justifyContent: 'center', alignItems: 'center' }}

                        >
                            <h3 className="task-Tab-heading   font-weight500    font-size-heading text-center ">Choose Avatar </h3>
                            <div onClick={triggerFileInput} style={{ cursor: 'pointer', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', marginBottom: '20px', }}>
                                <div
                                    style={{
                                        width: '90px',
                                        height: '90px',
                                        borderRadius: '50%',
                                        backgroundColor: 'rgb(200 223 243)',
                                        position: 'relative',
                                        margin: 'auto',
                                        // marginTop: '20px',
                                    }}
                                >
                                    {imagePreview ? (
                                        <img
                                            src={imagePreview}
                                            alt="Profile Pic"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    ) :
                                        selectedProfile ? (
                                            <img
                                                // src={selectedProfilePic}
                                                // src={`https://cipl-aimantra.s3.ap-south-1.amazonaws.com/${selectedProfile}`
                                                src={
                                                    selectedProfile.startsWith("http")
                                                        ? selectedProfile
                                                        : `https://cipl-aimantra.s3.ap-south-1.amazonaws.com/${selectedProfile}`
                                                }
                                                alt="Selected Avatar"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        ) : (
                                            <span
                                                style={{
                                                    fontWeight: '400',
                                                    position: 'absolute',
                                                    top: '-4px',
                                                    fontSize: '68px',
                                                    right: '21px',
                                                    color: '#2576bc',
                                                }}
                                            >
                                                +
                                            </span>
                                            // <div className="align-center justify-center">
                                            //     <AddwithBlueCircle />
                                            // </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div style={{ textAlign: 'center', cursor: 'pointer', color: '#2576bc', marginBottom: '10px' }} onClick={triggerFileInput}>Change from Files</div>

                            <input
                                id="fileInput"
                                type="file"
                                accept="image/*"
                                onChangeCapture={(event) => {
                                    handleImageUpload(event);
                                    resetFileInput();
                                }}
                                onChange={handleImageUpload}
                                style={{
                                    display: 'none',
                                }}
                            />
                            {pre_options && <div className="grid-container">
                                {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((num) => (
                                    <div
                                        key={num}
                                        className={`${"selected_profile_avatar"
                                            }`}
                                        style={{
                                            margin: '5px',
                                            border: selectedProfile === `user_profilepics/${num}.png` ? '2px solid #2576bc' : 'none',
                                            boxShadow:
                                                selectedProfile === `user_profilepics/${num}.png`
                                                    ? '0px 0px 10px rgba(0, 123, 255, 0.5)'
                                                    : 'none',
                                            // borderRadius: '10px',
                                        }}
                                    >
                                        <img
                                            src={`https://cipl-aimantra.s3.ap-south-1.amazonaws.com/user_profilepics/${num}.png`}
                                            alt={`avatar ${num}`}
                                            style={{ width: '100%', height: '100%', cursor: 'pointer' }}
                                            onClick={() => handleSelection(`user_profilepics/${num}.png`)}
                                        />
                                    </div>
                                ))}
                            </div>}
                            <div className="button-models">
                                <button className="model-button   font-weight500    model-button-cancel font-size-heading" onClick={handleClose} disabled={loading}>
                                    Cancel
                                </button>
                                {/* {selectedProfile === "" ? */}
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    // onClick={handleSubmit}
                                    // onClick={(e) => uploadFile(formDataa.profilepic)}
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Upload Profile
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );


}
export default ProfileUploadModal;